import axios from "axios";

export const state = {
    reportsharesbymonths: [],
};

export const getters = {
    reportsharesbymonths: state => state.reportsharesbymonths,
};

export const mutations = {
    setReportSharesbyMonths(reportsharesbymonths, newValue) { state.reportsharesbymonths = newValue},
};

export const actions = {
    async fetchReportSharesbyMonths({ commit }) {
        await axios.get('/reportsharesbymonths').then(res => {
            commit('setReportSharesbyMonths', res.data.shares)
        })
    },
    async filterReportSharesbyMonths({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filterreportsharesbymonths";
        await axios.post(url, formData).then((response) => {
            commit('setReportSharesbyMonths', response.data.shares)
        })
    },
};
